import { render, staticRenderFns } from "./UploadMultiple.vue?vue&type=template&id=80ffa728&scoped=true"
import script from "./UploadMultiple.vue?vue&type=script&lang=js"
export * from "./UploadMultiple.vue?vue&type=script&lang=js"
import style0 from "./UploadMultiple.vue?vue&type=style&index=0&id=80ffa728&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ffa728",
  null
  
)

export default component.exports